(function ($) {

    $(".faq .panel-heading").on("click", function (event) {

        let $accordion = $(this).closest(".panel-accordion");
        let $collapse = $accordion.find(".panel-collapse");

        if ($collapse.hasClass("show")) {
            $(this).animate({ paddingTop: 24, paddingBottom: 24 }, 200);
            $collapse.slideUp().removeClass("show");
            $accordion.removeClass('opened');
        } else {
            $(".faq .panel-accordion").not($accordion).each(function () {
                $(this).find(".panel-heading").animate({ paddingTop: 24, paddingBottom: 24 }, 200);
                $(this).removeClass("opened");
                $(this).find(".panel-collapse.show").slideUp().removeClass("show");
            });

            $(this).animate({ paddingTop: 48, paddingBottom: 16 }, 200);
            $collapse.slideDown().addClass("show");
            $accordion.addClass('opened');
        }
    });

})(jQuery);